<script lang="ts" module>
  import { applyAction, enhance } from '$app/forms';
  import { refreshAll } from '$app/navigation';
  import FloatingLabel from '#lib/components/FloatingLabel.svelte';
  import Modal from '#lib/components/Modal.svelte';
  import type { schema } from '#lib/server/drizzle/index.js';

  export type HpAddInfo =
    | {
        type: 'dkc';
        parent: typeof schema.system.$inferSelect;
        siblings: (typeof schema.dkc.$inferSelect)[];
      }
    | {
        type: 'controller';
        parent: typeof schema.dkc.$inferSelect;
        siblings: (typeof schema.controller.$inferSelect)[];
      }
    | {
        type: 'channelBoard';
        parent: typeof schema.controller.$inferSelect;
        siblings: (typeof schema.channelBoard.$inferSelect)[];
      }
    | {
        type: 'fePort';
        parent: typeof schema.channelBoard.$inferSelect;
      };

  export const hpAddNames = <const>{
    dkc: 'DKC',
    controller: 'Controller',
    channelBoard: 'Channel Board',
    fePort: 'Port',
  };

  const conventionRegex = /^([A-Z]+)(-?)(\d+)$/;

  const idxToLetter = (i: number) => String.fromCharCode('A'.charCodeAt(0) + i);
</script>

<script lang="ts">
  let info = $state<HpAddInfo>();
  let open = $state(false);

  let value = $derived.by(() => {
    let parentMatch = info?.parent.name.match(conventionRegex);

    if (info?.type === 'dkc') {
      return `DKC${info.siblings.length ?? '0'}`;
    } else if (info?.type === 'controller' && parentMatch) {
      return `CTL-${parentMatch[3]}${info.siblings.length + 1}`;
    } else if (info?.type === 'channelBoard' && parentMatch) {
      return `CHB-${parentMatch[3]}${idxToLetter(info.siblings.length)}`;
    }

    return '';
  });

  export function openModal(_info: HpAddInfo) {
    open = true;
    info = _info;
  }
</script>

<Modal header="Add a {info ? hpAddNames[info.type] : ''}" bind:open>
  <form
    method="post"
    action="?/addHpSub"
    use:enhance={() => {
      return async ({ result }) => {
        await applyAction(result);

        if (result.type === 'success') {
          await refreshAll();
          open = false;
        }
        //else if (result.type === 'failure') error = result.data?.error ?? {};
      };
    }}
  >
    <input class="hidden" hidden type="text" name="type" value={info?.type} />
    <input class="hidden" hidden type="text" name="parentId" value={info?.parent.id} />
    <FloatingLabel title="Name">
      {#snippet input(placeholder)}
        <input type="text" name="name" class="input w-full" bind:value {placeholder} />
      {/snippet}
    </FloatingLabel>

    <div class="modal-action">
      <button class="btn btn-secondary btn-ghost" type="reset" onclick={() => (open = false)}>
        Cancel
      </button>
      <button class="btn btn-primary" type="submit"> Add </button>
    </div>
  </form>
</Modal>
